<script>
import { MODAL } from '@/src/constants/Text'
import { GlobalBus } from '@/src/services/bus'
import globalModalChatIa from '@modules/global/modal/global-modal-chat-ia/global-modal-chat-ia.vue'

export default {
  name: 'TopChatIaPopUp',
  components: { globalModalChatIa },
  props: {
    showConversation: {
      type: Boolean,
      default: false,
    },
    showChat: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    subtituloDoHeader() {
      return this.showConversation ? 'Histórico do chat' : 'Geral'
    },
  },

  methods: {
    openModalFull() {
      GlobalBus.$emit(MODAL.GLOBAL_GLOBAL_CHAT_IA)
    },
  },
}
</script>

<template>
  <div>
    <div class="top-chat-ia-header d-flex align-center justify-space-between">
      <div class="d-flex align-center">
        <div class="top-chat-ia-header__avatar">
          <icon-svg name="ia-w-mark" :size="20" color="var(--aawz-green-color)" />
        </div>
        <div class="top-chat-ia-header__text ml-2">
          <div class="top-chat-ia-header__title">AAWZ Intelligence</div>
          <div class="top-chat-ia-header__subtitle">
            {{ subtituloDoHeader }}
          </div>
        </div>
      </div>

      <!-- Sem menu "Mais opções": era 2 cliques (abrir menu, escolher item)
           pra qualquer uma das 3 ações — direto como ícone economiza o
           primeiro clique. "Ver histórico" ocupa o primeiro slot fora do
           histórico; dentro dele o mesmo slot vira "Voltar" (com texto, não
           só ícone) — troca de lugar em vez de empilhar mais um botão. -->
      <div class="d-flex align-center top-chat-ia-header__actions">
        <v-btn
          v-if="!showConversation"
          icon
          small
          class="top-chat-ia-header__icon-btn"
          aria-label="Ver histórico"
          title="Ver histórico"
          @click="$emit('setShowConversation')"
        >
          <icon-svg name="clock-filled" color="var(--neutral-700)" size="18" />
        </v-btn>

        <!-- <button> puro, não v-btn: o v-btn "text" (não-icon) do Vuetify
             carrega padding/min-width/height de algum bundle de CSS externo
             que nem `!important` no scoped consegue vencer (investigado — 2
             das folhas de estilo carregadas são cross-origin, bloqueadas
             pra introspecção, e é lá que a regra real parece morar). Botão
             HTML puro elimina a briga de cascata: controle total, sem
             depender de nenhuma classe de tamanho do Vuetify. -->
        <button
          v-else
          type="button"
          class="top-chat-ia-header__icon-btn top-chat-ia-header__back-btn"
          aria-label="Voltar"
          @click="$emit('setShowConversation')"
        >
          <icon-svg
            name="mdi-arrow-left"
              size="14"
          />
          Voltar
        </button>

        <v-btn
          icon
          small
          class="top-chat-ia-header__icon-btn"
          aria-label="Novo chat"
          title="Novo chat"
          @click="$emit('setNewMessage')"
        >
          <icon-svg name="add-circle" color="var(--neutral-700)" size="18" />
        </v-btn>

        <v-btn
          icon
          small
          class="top-chat-ia-header__icon-btn"
          aria-label="Chat em tela cheia"
          title="Chat em tela cheia"
          @click="openModalFull"
        >
          <icon-svg name="maximize" color="var(--neutral-700)" size="18" />
        </v-btn>

        <v-btn
          icon
          small
          class="top-chat-ia-header__icon-btn"
          aria-label="Fechar"
          title="Fechar"
          @click="$emit('setShowChat')"
        >
          <icon-svg name="close-circle" color="var(--neutral-700)" size="18" />
        </v-btn>
      </div>
    </div>
    <globalModalChatIa />
  </div>
</template>

<style lang="sass" scoped>
// Mesma superfície quente da sidebar do chat IA (--sidebar-warm-bg): o header
// escuro do #1939 destoava do redesign. Trocar o fundo obriga a inverter TUDO
// que estava por cima — os 8 ícones eram `white` e o par --overlay-on-dark-*
// existe só para fundo escuro. Contrastes medidos sobre --sidebar-warm-bg:
// --neutral-900 13.45 (título/ícones) e --neutral-700 6.98 (subtítulo).
// Cantos superiores arredondados acompanham o painel (chat-ia-pop-up.vue).
.top-chat-ia-header
  background: var(--sidebar-warm-bg)
  border-radius: 8px 8px 0 0
  padding: 10px 18px

.top-chat-ia-header__avatar
  width: 32px
  height: 32px
  border-radius: 50%
  // Círculo claro com a marca no verde institucional, e não o inverso: o verde
  // como FUNDO obrigava um glifo que não contrastava (branco dava 2.69).
  // O W em --aawz-green-color dá 2.43 sobre esta superfície, abaixo dos 3:1 da
  // WCAG 1.4.11 — permitido porque a regra ISENTA logotipo, e este glifo é a
  // marca AAWZ, não um ícone funcional. Decisão de produto: a identidade usa a
  // cor institucional exata. Se um dia virar ícone com significado próprio,
  // --success-text (5.21) é o substituto que passa.
  background: var(--white)
  display: flex
  align-items: center
  justify-content: center
  flex-shrink: 0

.top-chat-ia-header__title
  color: var(--neutral-900)
  font-size: 13px
  font-weight: 600
  line-height: 1.3

.top-chat-ia-header__subtitle
  color: var(--neutral-700)
  font-size: 11px
  line-height: 1.3

// Estilo GitHub: fundo claro sutil arredondado só no hover — o underlay padrão
// do Vuetify usa currentColor e não aparecia sobre o fundo quente.
//
// ⚠️ A cor NÃO vem da prop `color` do v-btn: o `isCssColor` do Vuetify 2 só
// reconhece `#`, `rgb(` e `hsl(`, então `var(--token)` virava a classe inválida
// `var(--neutral-700)--text` — prop morta. Quem colore é o `icon-svg` dentro.
.top-chat-ia-header__actions
  gap: 6px

.top-chat-ia-header__icon-btn
  transition: background-color 0.15s ease

  &:hover
    background-color: var(--sidebar-warm-hover) !important

// "Voltar": <button> HTML puro (não v-btn — ver comentário no template),
// mesmo tamanho/hover dos ícones vizinhos (28px de altura), com o texto do
// label ao lado do ícone.
.top-chat-ia-header__back-btn
  display: inline-flex
  align-items: center
  gap: 4px
  height: 28px
  padding: 0 8px
  border: none
  border-radius: 6px
  background: transparent
  color: var(--neutral-900)
  font-family: inherit
  font-size: 12px
  font-weight: 500
  line-height: 1
  cursor: pointer
</style>
